import React, {useEffect, useState, useRef} from 'react';
import styled from "styled-components";
import Carousel, {CarouselItem} from '@molecules/swiper/carousel';
import CountUp from 'react-countup';
import Icon from "@atoms/icon";


const stats = (props) => {
    const [startCounterUp, setStartCounterUp] = useState(false);
    const counterUpRef = useRef('');

    const breakpoints = {
        768: {
            slidesPerView: 3,
        },
        320: {
            slidesPerView: 1,
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            const target = counterUpRef.current;
            const position = (target.offsetTop + (target.clientHeight / 2) < window.scrollY + window.innerHeight);
            if (position && !startCounterUp) {
                setStartCounterUp(true);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll)
    });

    return (
        <Container className={" " + (props.className ?? '')} ref={counterUpRef}>
            <Carousel breakpoints={breakpoints} autoplay={true} navigation_show={false} pagination={false} className={(props.carouselClassName ?? '')}>
                {
                    props.statItems.map((item, key) =>
                        <CarouselItem key={key}>
                            <div className="d-flex flex-column align-items-center text-center stats-carousel-item">
                                {
                                    (typeof item.icon !== "undefined") ?
                                        <StatCardImage className="mb-16">
                                            {item.icon}
                                        </StatCardImage>
                                        : ''
                                }

                                <div className="h1-bold">
                                    <CountUp
                                        suffix="+"
                                        separator="٫"
                                        end={startCounterUp ? item.num : 0}/>
                                </div>
                                <div className="h3-normal font-weight-bold font-weight-lg-normal">{item.label}</div>
                            </div>
                        </CarouselItem>
                    )
                }
            </Carousel>
        </Container>
    )
};
export default React.memo(stats);

// styles

const StatCardImage = styled(Icon)`
  width: 124px;
  height: 124px;
`;

const Container = styled.section`
    .swiper-slide {
        margin: 0;
    }
    
    .carousel-pagination {
        @media(min-width: ${props => props.theme.screenXsMax}) {
            display: none;
        }
    }
    
    .h1-bold {
        font-size: 2.5rem;
    }
    
    .swiper-container {
        padding-bottom: 24px;
        margin-bottom: -24px;
        
        @media(min-width: ${props => props.theme.screenSmMax}) {
            overflow: visible;
        }
    }
`;